export const generateRules = function ($t) {
  return {
    url: [
      {required: true, message: $t.bind(this)('settings.customerRules.url'), trigger: 'blur'},
    ],
    name: [
      {required: true, message: $t.bind(this)('settings.customerRules.name'), trigger: 'blur'},
    ],
    mail: [
      {required: true, type: 'email', message: $t.bind(this)('settings.customerRules.email'), trigger: 'blur'},
    ],
    appLoginDomain: [
      {required: true, message: $t.bind(this)('settings.customerRules.appLoginName'), trigger: 'blur'},
    ],
    loginDomain: [
      {required: true, message: $t.bind(this)('settings.customerRules.loginName'), trigger: 'blur'},
    ],
    user: [
      {required: true, message: $t.bind(this)('settings.customerRules.user'), trigger: 'blur'},
    ],
    password: [
      {required: true, message: $t.bind(this)('settings.customerRules.password'), trigger: 'blur'},
    ]
  }
};
